import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PagePracticesModel } from '../../_models/page-practices.model';
import { Store } from '@ngxs/store';
import { PracticeState } from '../../_stores/practice/_state/practice.state';
import { UserState } from '../../_stores/user/_state/user.state';
import { SetPracticeToUser } from '../../_stores/user/_actions/user.actions';

@Component({
  selector: 'ui-practice',
  templateUrl: './ui-practice.component.html',
  styleUrls: ['./ui-practice.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UiPracticeComponent implements OnInit {
  interface: PagePracticesModel = {
    grades: [],
    categories: [],
    user: undefined,
    _cache: {
      open_choose_grade: false,
      choose_grade: undefined,
    },
  };

  constructor(private store: Store, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.initGrades();
    this.initCategories();
    this.initUser();
  }

  initGrades(): void {
    this.store.select(PracticeState.selectGrades).subscribe((_grades) => {
      this.interface.grades = _grades;
      this.cdr.detectChanges();
    });
  }

  initCategories(): void {
    this.store.select(PracticeState.selectCategories).subscribe((_categories) => {
      this.interface.categories = _categories;
      this.cdr.detectChanges();
    });
  }

  initUser(): void {
    this.store.select(UserState.selectUser).subscribe((_user) => {
      this.interface.user = _user;
      this.cdr.detectChanges();
    });
  }

  getCurrentUserGrade(): string {
    const _grade = this.interface.grades?.find((grade) => grade._id === this.interface.user?.practice);
    return _grade ? _grade.title : '';
  }

  actionToggleChooseGrade(): void {
    this.interface._cache.open_choose_grade = !this.interface._cache.open_choose_grade;
  }

  actionChooseGrade(grade): void {
    this.store.dispatch(new SetPracticeToUser(grade._id));
    this.actionToggleChooseGrade();
    this.cdr.detectChanges();
  }
}
